/*
 * Copyright © Digibaneh. All rights reserved.
 * @author: Amin Latifkar <amin.latifkar@gmail.com>
 */

function getTitle (vm: any) {
    const { title } = vm;
    if (title) {
        return typeof title === 'function'
            ? title.call(vm)
            : title
    }
}
export default {
    created () {
        const title = getTitle(this)
        if (title) {
            document.title = title
        }
    }
}